import { Link } from "react-router-dom";
import { brandAssets, company, highlights } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 text-background-50">
      <div className="blueprint absolute inset-0 opacity-50" />
      <div className="absolute -left-32 top-1/2 h-[520px] w-[520px] -translate-y-1/2 rounded-full bg-primary-500/10 blur-3xl" />
      <div className="relative mx-auto w-full max-w-shell px-4 pb-10 pt-9 md:px-6 md:pb-14 md:pt-12">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div className="mb-5 flex flex-wrap items-center gap-3 font-label text-[10.5px] uppercase tracking-[0.22em] text-background-400">
              <span className="h-[2px] w-8 bg-primary-500" />
              Seit {company.founded} · {company.city}-Geschwand
            </div>

            <h1 className="max-w-2xl font-heading text-[32px] font-extrabold leading-[1.05] tracking-tightest sm:text-[42px] md:text-[50px]">
              Sondermaschinen,
              <br />
              die es nur
              <span className="ml-3 inline-block bg-primary-500 px-2 pb-0.5 text-background-50">
                einmal
              </span>
              gibt.
            </h1>

            <p className="mt-5 max-w-lg text-[14.5px] leading-relaxed text-background-300 md:text-[16px]">
              Wir entwickeln und fertigen Vorrichtungen, Sondermaschinen und Ver- und
              Entsorgungsanlagen aus Edelstahl. Dazu kommen Strom- und Wassersäulen für
              Campingplätze sowie Ladestationen für Elektrofahrzeuge.
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/unternehmen"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-primary-500 px-6 py-3.5 font-heading text-[12px] font-bold uppercase tracking-[0.14em] text-background-50 transition-colors hover:bg-primary-600"
              >
                Über uns
                <i className="ri-arrow-right-line text-[15px]" />
              </Link>
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-foreground-700 px-6 py-3.5 font-heading text-[12px] font-bold uppercase tracking-[0.14em] text-background-100 transition-colors hover:border-background-400 hover:text-background-50"
              >
                Kontakt aufnehmen
              </Link>
            </div>

            <dl className="mt-9 flex flex-wrap items-stretch divide-x divide-foreground-800">
              {highlights.map((item) => (
                <div
                  key={item.label}
                  className="flex-1 basis-1/3 pr-4 pl-0 first:pl-0 [&:not(:first-child)]:pl-5"
                >
                  <dt className="font-heading text-[24px] font-extrabold leading-none text-background-50 md:text-[28px]">
                    {item.value}
                  </dt>
                  <dd className="mt-1.5 font-label text-[10px] uppercase leading-relaxed tracking-[0.14em] text-background-500">
                    {item.label}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -left-3 -top-3 h-14 w-14 border-l-2 border-t-2 border-primary-500" />
              <div className="absolute -bottom-3 -right-3 h-14 w-14 border-b-2 border-r-2 border-foreground-700" />
              <div className="relative border border-foreground-800 bg-foreground-900/60 p-2">
                <div className="relative h-[200px] w-full overflow-hidden sm:h-[260px] lg:h-[320px]">
                  <img
                    src={brandAssets.machineDetailAlt}
                    alt="Blick in die Fertigung der Ulrich Arzt Präzisions-Mechanik in Geschwand"
                    width={800}
                    height={620}
                    className="h-full w-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between gap-3 p-4">
                    <div>
                      <p className="font-label text-[9.5px] uppercase tracking-[0.2em] text-primary-300">
                        Fertigung
                      </p>
                      <p className="mt-1 font-heading text-[14.5px] font-bold text-background-50">
                        Werk Geschwand
                      </p>
                    </div>
                    <span className="flex h-9 w-9 items-center justify-center border border-background-50/30 text-background-100">
                      <i className="ri-tools-line text-[15px]" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <p className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 font-label text-[10px] uppercase tracking-[0.16em] text-background-500">
              <span>CNC-Fertigung</span>
              <span className="text-primary-500">/</span>
              <span>Edelstahl</span>
              <span className="text-primary-500">/</span>
              <span>Montage</span>
            </p>
          </div>
        </div>
      </div>
      <div className="h-[3px] w-full bg-primary-500" />
    </section>
  );
}